const origin = window.location.origin;
let origin2 = 'https://northside.auratech.com.mx';
let origin2Dev = 'https://northside.development.auratech.com.mx';
let origin2Stag = 'https://northside.staging.auratech.com.mx';

// let domain = "https://api.xrprompter.ih3innohub.com";

// AZURE
// https://xrprompterfront-dev.azurewebsites.net/ - dev.api.xrprompter.com
// https://xrprompterfront-main.azurewebsites.net/ - api.xrprompter.com
// https://xrprompterfront-qa.azurewebsites.net/ - api.qa.xrprompter.com
// let domain = "https://api.holodox.mx"
let domain = 'https://api.development.holodox.mx';

if (origin == 'https://www.holodox.mx' || origin == origin2) {
	domain = 'https://api.holodox.mx';
}
if (origin == 'https://staging.holodox.mx' || origin == origin2Stag) {
	domain = 'https://api.staging.holodox.mx';
}
if (origin == 'https://development.holodox.mx' || origin == origin2Dev) {
	domain = 'https://api.development.holodox.mx';
}
//domain = 'https://api.development.holodox.mx';
//domain = "http://ec2-34-216-223-196.us-west-2.compute.amazonaws.com"
//domain = "https://api.development.holodox.mx"

export const ONLY_DOMAIN = domain;
//export const ONLY_DOMAIN = process.env.REACT_APP_API_DOMAIN
//console.log('ONLY_DOMAIN',process.env.REACT_APP_API_DOMAIN)
export const DOMAIN = ONLY_DOMAIN + '/api';
export const URL_LOGIN_AZURE = ONLY_DOMAIN + '/login/azure';
export const MENSAJE_ERROR = 'Ha ocurrido un error inesperado. Intenta más tarde.';
